export default __webpack_public_path__ + "static/media/icon-3pts-blanc.7fd10018.svg";